module.exports = __webpack_public_path__ + "static/media/bandung.2636affc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bandung.jpg
// module id = 128
// module chunks = 0